export const DEFAULT_SKILL_ICON = 'bi-award';

export const ICON_OPTIONS = [
  ['bi-award', 'Award'], ['bi-code-slash', 'Code'], ['bi-braces', 'Programming'],
  ['bi-terminal', 'Terminal'], ['bi-filetype-js', 'JavaScript'], ['bi-filetype-py', 'Python'],
  ['bi-database', 'Database'], ['bi-cloud', 'Cloud'], ['bi-globe2', 'Web'],
  ['bi-phone', 'Mobile'], ['bi-palette', 'Design'], ['bi-pencil', 'Writing'],
  ['bi-camera', 'Photography'], ['bi-bar-chart', 'Analytics'], ['bi-graph-up-arrow', 'Growth'],
  ['bi-people', 'Teamwork'], ['bi-chat-dots', 'Communication'], ['bi-lightbulb', 'Ideas'],
  ['bi-gear', 'Engineering'], ['bi-tools', 'Tools'], ['bi-shield-check', 'Security'],
  ['bi-check2-circle', 'Quality'], ['bi-briefcase', 'Business'], ['bi-mortarboard', 'Learning'],
  ['bi-translate', 'Languages'], ['bi-music-note-beamed', 'Music'], ['bi-heart', 'Care'],
  ['bi-star', 'Expertise'], ['bi-lightning', 'Performance'], ['bi-diagram-3', 'Architecture'],
].map(([value, label]) => ({ value, label }));

export const normalizeSkillIcon = (icon) => {
  if (icon?.type === 'bootstrap' && typeof icon.value === 'string' && /^bi-[a-z0-9-]+$/.test(icon.value)) {
    return { type: 'bootstrap', value: icon.value };
  }
  if (icon?.type === 'image' && typeof icon.imageId === 'string' && icon.imageId.trim()) {
    return { type: 'image', imageId: icon.imageId.trim() };
  }
  return null;
};
